import React, { Component } from 'react';
import styled from 'styled-components';
import Button from 'ui/controls/Button';
import NotificationConductor from 'common/conductors/NotificationConductor';
import { BACKGROUNDS, COLORS } from 'themes/index';
import { byPlatform, isDesktop } from 'utils/platforms';

const ButtonWrapper = styled.div`
    display: flex;
    position: relative;
    height: 100%;
    flex-flow: column;
    justify-content: center;
`;

export const StyledButton = styled(Button)`
    transition: background 300ms ease;
    ${isDesktop && 'height: 30px'};
    ${isDesktop && 'line-height: 13px'};
    opacity: ${({ scratched }) => (scratched ? 0.4 : 1)};
    cursor: ${({ scratched, active }) =>
        scratched && !active ? 'default' : 'pointer'};
    font-size: 16px;
    font-weight: 900;
    padding: 0;
    margin: 0;
    width: ${({ betButtonStyles = {} }) =>
        (betButtonStyles.width
            ? betButtonStyles.width
            : byPlatform('30', '30', '45')) + 'px;'};
    height: ${({ betButtonStyles = {} }) =>
        (betButtonStyles.width
            ? betButtonStyles.width
            : byPlatform('30', '30', '45')) + 'px;'};
    border: ${({ active, reserved }) =>
        active || reserved ? 0 : '0.5px solid #C6CCDB'};
    color: ${({ active, reserved }) =>
        active || reserved ? COLORS.white : '#333333'};
    background: ${({ active, reserved, raceFinished }) => {
        if (active && reserved) {
            return `linear-gradient(45deg, #04a358 0%,#36b575 51%,#207cca 51%,#2989d8 51%,#0091d6 100%);`;
        }
        if (active) {
            return BACKGROUNDS.primary;
        }
        if (raceFinished) {
            return BACKGROUNDS.lightGrey;
        }
        if (reserved) {
            return BACKGROUNDS.blue;
        }

        return BACKGROUNDS.lightGrey;
    }};
    // when race has finished
    ${({ raceFinished }) => raceFinished && `color: ${COLORS.black}`};
    ${({ raceFinished }) => raceFinished && `border: 0`};
    ${({ raceFinished }) => raceFinished && `cursor: default`};
    ${({ raceFinished }) => raceFinished && `background: none`};

    &:hover {
        background: ${({ active }) => !active && '#c6ccdb'};
    }
`;

const ReserveNumber = styled.span`
    display: block;
    background: ${BACKGROUNDS.accentAlt};
    height: 12px;
    width: 12px;
    line-height: 13px;
    border-radius: 10px;
    left: 8px;
    position: absolute;
    font-size: 8px;
    color: ${COLORS.black};
    transform: translate(21px, -28px);
`;

class BetButton extends Component {
    toggle = (e) => {
        e.stopPropagation();

        const { startNumber, reserved, reserveModeEnabled } = this.props;
        if (reserveModeEnabled) {
            !reserved
                ? this.props.addReserve && this.props.addReserve(startNumber)
                : this.props.removeReserve &&
                  this.props.removeReserve(startNumber);
        } else {
            this.isActive()
                ? this.props.onDisactivate &&
                  this.props.onDisactivate(this.props.betValue)
                : this.props.onActivate &&
                  this.props.onActivate(this.props.betValue);
        }
    };

    showNotificationScratchedHorse = (e) => {
        e.stopPropagation();
        NotificationConductor.info('Hesten er udgået');
    };

    showNotificationRaceStarted = (e) => {
        e.stopPropagation();
        NotificationConductor.info(
            'Det er ikke muligt at spille på dette løb, da det er gået igang'
        );
    };

    clickHandler = (e) => {
        // race has finished
        if (this.props.raceFinished) {
            return;
        }

        if (this.props.raceStarted) {
            return this.showNotificationRaceStarted(e);
        }

        if (this.props.scratched && !this.isActive()) {
            return this.showNotificationScratchedHorse(e);
        }

        this.toggle(e);
    };

    isActive = () => {
        const { bet, betValue, startNumber } = this.props;
        return bet.satisfies(startNumber, betValue);
    };

    render() {
        return (
            <ButtonWrapper>
                <StyledButton
                    {...this.props}
                    active={this.isActive()}
                    // secondary={!this.isActive()}
                    size="x1"
                    onClick={this.clickHandler}
                    disabled={this.props.scratched && !this.isActive()}
                    scratched={this.props.scratched}
                    //disabled={this.props.scratched || this.props.raceStarted}
                >
                    {this.props.betValue}
                    {this.props.reserved && (
                        <ReserveNumber>
                            {this.props.reserveNumber}
                        </ReserveNumber>
                    )}
                </StyledButton>
            </ButtonWrapper>
        );
    }
}

export default BetButton;
